/* eslint-disable */

export const getUrlParam = function(name, search = window.location.search) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
  var r = search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export const getSearchParams = (search = "") => {
  search = search.replace("?", "")
  const arr = search.split("&")
  const obj = {}
  arr.forEach(item => {
    const arr1 = item.split("=")
    const key = arr1[0]
    const value = arr1[1] || ""
    if (key && value !== "") {
      obj[key] = value
    }
  })
  return obj
}

export const queryString = (obj = {}) => {
  let result = []
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      result.push(`${key}=${obj[key]}`)
    }
  })
  return result.join("&")
}

export const resolveShareLayer = (url = window.location.href) => {
  const searchReg = /\?[^#]*/
  const urlMatch = url.match(searchReg) || []
  let urlSearch = urlMatch[0] || ""
  let layer = getUrlParam("layer") || 0
  layer = Number(layer)
  layer++
  if (urlSearch) {
    const searchParams = getSearchParams(urlSearch)
    searchParams.layer = layer
    const searchQueryString = queryString(searchParams)
    return url.replace(searchReg, `?${searchQueryString}`)
  } else {
    urlSearch += `?layer=${layer}`
    const index = url.indexOf("#/")
    if (index > -1) {
      return url.split("#/")[0] + urlSearch + "#/" + url.split("#/")[1]
    } else {
      return url + urlSearch
    }
  }
}

export const getDevicedId = () => {
  var key = "nfplus_deviceid"
  function guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
  function isLocalStorageSupported() {
    var testKey = "localstorage_support_test",
      storage = window.sessionStorage
    try {
      storage.setItem(testKey, "testValue")
      storage.removeItem(testKey)
      return true
    } catch (error) {
      return false
    }
  }
  if (isLocalStorageSupported()) {
    var deviceid = window.localStorage.getItem(key) || ""
    if (deviceid == "") {
      deviceid = guid()
      window.localStorage.setItem(key, deviceid)
    }
    return deviceid
  } else {
    return guid()
  }
}

const shence_sdk_url = {
  dev: {
    sdk_url: "//static.nfapp.southcn.com/record/sensor/sensorsdata.min.js",
    heatmap_url: "//static.nfapp.southcn.com/record/sensor/heatmap.min.js",
    name: "sensors",
    server_url: "https://caiji.nfapp.southcn.com/god/sa?project=default",
    heatmap: { scroll_notice_map: "default" }
  },
  test: {
    sdk_url: "//static.nfapp.southcn.com/record/sensor/sensorsdata.min.js",
    heatmap_url: "//static.nfapp.southcn.com/record/sensor/heatmap.min.js",
    name: "sensors",
    server_url: "https://caiji.nfapp.southcn.com/god/sa?project=default",
    heatmap: { scroll_notice_map: "default" }
  },
  pro: {
    sdk_url: "//static.nfapp.southcn.com/record/sensor/sensorsdata.min.js",
    heatmap_url: "//static.nfapp.southcn.com/record/sensor/heatmap.min.js",
    name: "sensors",
    server_url: "https://caiji.nfapp.southcn.com/god/sa?project=production",
    heatmap: { scroll_notice_map: "default" }
  }
}

export const initRecordSDK = (env = "pro") => {
  var url = shence_sdk_url[env]
  ;(function(para) {
    var p = para.sdk_url,
      n = para.name,
      w = window,
      d = document,
      s = "script",
      x = null,
      y = null
    if (typeof w["sensorsDataAnalytic201505"] !== "undefined") {
      return false
    }
    w["sensorsDataAnalytic201505"] = n
    w[n] =
      w[n] ||
      function(a) {
        return function() {
          ;(w[n]._q = w[n]._q || []).push([a, arguments])
        }
      }
    var ifs = [
      "track",
      "quick",
      "register",
      "registerPage",
      "registerOnce",
      "trackSignup",
      "trackAbtest",
      "setProfile",
      "setOnceProfile",
      "appendProfile",
      "incrementProfile",
      "deleteProfile",
      "unsetProfile",
      "identify",
      "login",
      "logout",
      "trackLink",
      "clearAllRegister",
      "getAppStatus"
    ]
    for (var i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i])
    }
    if (!w[n]._t) {
      ;(x = d.createElement(s)), (y = d.getElementsByTagName(s)[0])
      x.async = 1
      x.src = p
      x.setAttribute("charset", "UTF-8")
      w[n].para = para
      y.parentNode.insertBefore(x, y)
    }
  })(url)

  window.sensors.registerPage({
    platform: "web",
    userUuid: "",
    deviceId: getDevicedId(),
    userAgent: navigator.userAgent
  })

  window.sensors.quick("autoTrack", {
    platform: "web"
  })
}

export const buryingPoint = (options = {}, env = process.env.VUE_APP_RUN_ENV, headers = {}) => {
  const buryingPointUrl = {
    dev: "https://devanalyticsapi.nfnews.com/analytics/sendRecord",
    test: "https://testanalyticsapi.nfnews.com/analytics/sendRecord",
    pro: "https://analyticsapi.nfnews.com/analytics/sendRecord"
  }
  const baseUrl = buryingPointUrl[env]
  const baseParams = {
    deviceid: getDevicedId(),
    dataType: 1000255,
    actionTime: new Date()
      .getTime()
      .toString()
      .slice(0, 13),
    url: encodeURIComponent(window.location.href),
    refer: document.referrer || "",
    layer: getUrlParam("layer") || "",
    from: getUrlParam("from") || "",
    origin: 1,
    activityId: "",
    action: ""
  }
  Object.assign(baseParams, options)
  let img = new Image()
  img.src = `${baseUrl}?${queryString(baseParams)}`
  img = null
}
